import React from "react";
import FirstwhoLogoText from "../svgs/firstwho-logo-text";

const HiringFooter = () => (
  <div className="container">
    <section>
      <div className="my-4 border-t border-gray-200 pt-8">
        <a
          href="https://firstwho.co"
          target="_new"
          className="flex"
          style={{
            transform: "scale(.50)",
            transformOrigin: "top left"
          }}
        >
          <span className="text-2xl text-gray-400 self-end mr-4">
            Powered by{" "}
          </span>
          <FirstwhoLogoText />
        </a>
      </div>
    </section>
  </div>
);

export default HiringFooter;
